import type {LazyImageProps} from './LazyImage'

export const getPlaceholderDataUrl = (
  width: LazyImageProps['width'] = 16,
  height: LazyImageProps['height'] = 9,
): string => {
  if (typeof width === 'string') {
    width = parseInt(width)
  }
  if (isNaN(width)) {
    width = 16
  }
  if (typeof height === 'string') {
    height = parseInt(height)
  }
  if (isNaN(height)) {
    height = 9
  }

  const canvas = document.createElement('canvas')

  const ctx = canvas.getContext('2d')

  if (!ctx) {
    throw new Error('Canvas 2D context is not supported')
  }

  canvas.width = Math.max(width, 1)
  canvas.height = Math.max(height, 1)
  return canvas.toDataURL()
}
